import axios from "axios";
import { BASE_URL } from ".";
import { 
    CreatePaymentIntentRequest, 
    CreatePaymentRequest,
    CurrentPlanResponse,
    StripePaymentRequest,
    StripePaymentResponse,
    PayPalPaymentRequest,
    PayPalPaymentResponse,
    RefundAmountResponse,
    RefundResponse,
    StartFreeTrialResponse,
    CheckPaymentStatusResponse,
    CheckFreeTrialStatusResponse
} from "../types/Payment";

export class PaymentService {
    public static async createPaymentIntent(data: CreatePaymentIntentRequest) {
        const response = await axios.post(BASE_URL + '/payment/create-intent', data);
        return response.data;
    }

    public static async createPaymen(data: CreatePaymentRequest) {
        const response = await axios.post(BASE_URL + '/payment/create', data);
        return response.data;
    }

    // 获取用户当前的plan - 更新API路径
    public static async getCurrentPlan(): Promise<CurrentPlanResponse> {
        const response = await axios.get(BASE_URL + '/edit-api/get-current-plan');
        return response.data;
    }

    // Stripe付款接口 - 更新请求参数
    public static async payByStripe(data: StripePaymentRequest): Promise<StripePaymentResponse> {
        const response = await axios.post(BASE_URL + '/edit-api/pay-by-stripe', data);
        return response.data;
    }

    // PayPal付款接口 - 更新请求参数
    public static async payByPayPal(data: PayPalPaymentRequest): Promise<PayPalPaymentResponse> {
        const response = await axios.post(BASE_URL + '/edit-api/pay-by-paypal', data);
        return response.data;
    }

    // 获取用户退款额度
    public static async getRefundAmount(): Promise<RefundAmountResponse> {
        const response = await axios.get(BASE_URL + '/edit-api/refund-amount');
        return response.data;
    }

    // 退款接口
    public static async refund(): Promise<RefundResponse> {
        const response = await axios.post(BASE_URL + '/edit-api/request-refund');
        return response.data;
    }

    // 新增免费试用接口
    public static async startFreeTrial(): Promise<StartFreeTrialResponse> {
        const response = await axios.post(BASE_URL + '/edit-api/start-free-trial/');
        return response.data;
    }

    // 检查支付状态
    public static async checkPaymentStatus(): Promise<CheckPaymentStatusResponse> {
        const response = await axios.get(`${BASE_URL}/edit-api/payment/status`);
        return response.data;
    }

    // 检查免费试用状态
    public static async checkFreeTrialStatus(): Promise<CheckFreeTrialStatusResponse> {
        const response = await axios.get(`${BASE_URL}/edit-api/check-free-trial`);
        return response.data;
    }

    // 选择 free plan
    public static async selectFreePlan(): Promise<{ status: string; message: string }> {
        const response = await axios.post(BASE_URL + '/edit-api/select-free-plan');
        return response.data;
    }
}
